import React, { useEffect } from 'react';

import { Navigate, Routes, Route } from 'react-router-dom';

import { loginActions, useStore } from '@modules';

import Error from '@pages/Error';
import Authorization from '@pages/login/Authorization';
import SetEmail from '@pages/login/SetEmail';
import SetPassword from '@pages/login/SetPassword';
import VerifyEmail from '@pages/login/VerifyEmail';
import VerifyOTP from '@pages/login/VerifyOTP';
import VerifyPassword from '@pages/login/VerifyPassword';
import VerifyPhone from '@pages/login/VerifyPhone';
import AccountBlocked from '@pages/user/AccountBlocked';

import { LoginContextProvider } from './LoginContext';

const LoginRoute: React.FC = () => {
  const [{ login }, dispatch] = useStore();

  useEffect(() => {
    dispatch(loginActions.clearNext());
  }, []);

  if (login.isLoggedIn) return <Navigate to={CONST.nav.root} />;

  return (
    <LoginContextProvider>
      <Routes>
        <Route path="email" element={<Authorization />} />
        <Route path="verify-email" element={<VerifyEmail />} />
        <Route path="verify-phone" element={<VerifyPhone />} />
        <Route path="verify-otp" element={<VerifyOTP />} />
        <Route path="verify-password" element={<VerifyPassword />} />
        <Route path="set-email" element={<SetEmail />} />
        <Route path="reset-password/verify-email" element={<VerifyEmail />} />
        <Route path="set-password" element={<SetPassword />} />
        <Route path="account-blocked" element={<AccountBlocked />} />
        <Route path="error" element={<Error />} />
        <Route path="*" element={<Navigate to="email" replace />} />
      </Routes>
    </LoginContextProvider>
  );
};

export default LoginRoute;
